import React from "react"
import withUseRouter, { UseRouterParams } from "services/router"
import {
	MatesComponent,
	MatesComponentState,
} from "components/mates-component"
import {
	ErrorResponse,
	Loading,
	RestResponse,
} from "@sinossi/mates-react-library"
import {
	PageHeader,
	PageSectionTitle,
	RoutesData,
} from "components/commons"
import {
	Box,
	Button,
	Divider,
    TextField,
} from "@mui/material"
import { t } from "@lingui/macro"
import { Link as RouterLink } from "react-router-dom"
import {
	AssetMatchBrand,
	SessionResponse,
} from "models"
import { MatchService } from "services/match.service"
import { SessionService } from "services/session.service"
import MatchProposalDetailsForm
	from "components/match-proposal/match-proposal-details/match-proposal-details-form/match-proposal-details-form"
import MatchProposalDetailsTimeline from "components/match-proposal/match-proposal-details/match-proposal-details-timeline"

/* const mockedTimeline = [
	{
		actionType: MatchActionType.VISIT,
		date: "2025-04-28T12:34:56.789Z",
		managedBy: "PLACEHOLDER MOCK",
		reason: "",
		oldStatus: AssetMatchesBrandStatus.INTERESTED,
		newStatus: AssetMatchesBrandStatus.INTERESTED,
		visitDate: "2025-04-30T12:34:56.789Z",
	},
	{
		actionType: MatchActionType.CHANGE_STATUS,
		date: "2025-04-27T12:34:56.789Z",
		managedBy: "PLACEHOLDER MOCK",
		reason: "",
		oldStatus: AssetMatchesBrandStatus.SENT,
		newStatus: AssetMatchesBrandStatus.INTERESTED,
		visitDate: ""
	},
	{
		actionType: MatchActionType.CALL,
		date: "2025-04-26T12:34:56.789Z",
		managedBy: "PLACEHOLDER MOCK",
		reason: "conferma ricezione",
		oldStatus: AssetMatchesBrandStatus.SENT,
		newStatus: AssetMatchesBrandStatus.SENT,
		visitDate: ""
	},
	{
		actionType: MatchActionType.SENT,
		date: "2025-04-25T12:34:56.789Z",
		managedBy: "PLACEHOLDER MOCK",
		reason: "",
		oldStatus: AssetMatchesBrandStatus.SENT,
		newStatus: AssetMatchesBrandStatus.SENT,
		visitDate: ""
	}
] */

interface MatchProposalDetailsState extends MatesComponentState {
	loading: boolean,
	match: AssetMatchBrand | null,
	sessionData: SessionResponse | null
}

class MatchProposalDetails extends React.Component<UseRouterParams, MatchProposalDetailsState> {
	private readonly matesComponent: MatesComponent<UseRouterParams, MatchProposalDetailsState> = new MatesComponent<UseRouterParams, MatchProposalDetailsState>(this)

	constructor(props: UseRouterParams)
	{
		super(props)
		this.state = {
			...this.matesComponent.setupState(),
			loading: true,
			match: null,
			sessionData: null
		}
	}

	componentDidMount() {
		this.fetchMatchData()
		this.fetchSessionData()
	}

	private fetchSessionData = () => {
		SessionService.getSession(this.getSessionCallback, this.matesComponent.onError)
	}

	private getSessionCallback = (response: RestResponse<SessionResponse, ErrorResponse>) => {
		if(response.hasError()){
			this.matesComponent.onError(response)
			return
		}

		this.setState(() => ({
			sessionData: response.data
		}))
	}

	private fetchMatchData = () => {
		const matchId = window.location.href.split("/")[window.location.href.split("/").length - 1]

		this.setState(() => ({
			loading: true
		}))
		MatchService.getMatchById(matchId, this.getMatchCallback, this.matesComponent.onError)
	}

	private getMatchCallback = (response: RestResponse<any, ErrorResponse>) => {
		if(response.hasError()){
			this.matesComponent.onError(response)
			this.setState(() => ({
				loading: false
			}))
			return
		}

		this.setState(() => ({
			loading: false,
			match: response.data
		}))
	}

	render() {
		return (
			<Box sx={{ width: '100%', pt: 2, position: "relative" }}>
				<Loading show={this.state.loading} />
				<PageHeader
					title={RoutesData.MATCH_PROPOSAL_DETAILS.title}
					paths={[RoutesData.DASHBOARD, RoutesData.MATCH_PROPOSAL, RoutesData.MATCH_PROPOSAL_DETAILS]}
				/>
				<Box
					sx={{
						height: "70vh",
						width: "100%",
						backgroundColor: "background.default",
						display: "flex",
						justifyContent: "space-between"
					}}
				>
					<Box
						sx={{
							width: "70%",
						}}
					>
						<PageSectionTitle title={t({ id: "mpd.form-title", message: `Proposta per: ${this.state.match?.asset.address}`})}>
							{
								this.state.match &&
								<Button
									variant="outlined"
									size="small"
									component={RouterLink}
									to={`/asset/${this.state.match.asset.id}`}
									sx={{
										color: "primary.contrastText",
										borderColor: "primary.contrastText",
										"&:hover": {
											borderColor: "primary.contrastText",
											backgroundColor: "rgba(255,255,255,0.1)"
										}
									}}
								>
									{t({
										id: "mpd.go-to-asset",
										message: "Vai all'asset",
									})}
								</Button>
							}
						</PageSectionTitle>
						{
							this.state.match &&
							<MatchProposalDetailsForm 
								match={this.state.match} 
								refreshData={this.fetchMatchData}
								sessionData={this.state.sessionData || undefined}
							/>
						}
					</Box>
					<Box
						sx={{
							my: 10
						}}
					>
						<Divider orientation="vertical" />
					</Box>
					<Box
						sx={{
							width: "25%",
							mb: 4,
							mt: 2,
							pt: 2,
							maxHeight: "70vh",
							overflow: "auto"
						}}
					>
						<TextField
							disabled
							variant={'outlined'}
							label={t({
								id: "mpd.executor",
								message: "Gestito da",
							})}
							name="executor"
							value={this.state.match?.proposta.accountManager.accountDetails?.firstName + " " + this.state.match?.proposta.accountManager.accountDetails?.lastName}
							sx={{
								mb: 2
							}}
						/>
						{!this.state.loading && this.state.match!.proposta.propostaTimeline && <MatchProposalDetailsTimeline timelineId={this.state.match!.proposta.propostaTimeline.id}/>}
					</Box>
				</Box>
			</Box>
		)
	}
}

export default withUseRouter(MatchProposalDetails)
